var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip"},_vm._l((_vm.chips),function(chip){return _c('button',{key:chip.id,staticClass:"chip__button",class:{
      'chip__button--filled': _vm.filled.includes(chip.id)
    },attrs:{"type":"button"},on:{"click":function($event){return _vm.onClick(chip.id)}}},[_vm._v("\n    "+_vm._s(chip.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }